<div class="footer" *ngIf="location !== 'dashboard'">
    <p>© Eyezilla, {{currentYear}}</p>
</div>
<div class="footer-main" *ngIf="location === 'dashboard'">
    <p>© Eyezilla </p>
</div>
